import { ClickButton } from '../../../shared/Anchor/Anchor.styled';
import { PalletteProps } from '../../../types/theme/pallette';
import styled from 'styled-components';

export const DateAndTimeWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: center;
`;

export const DateMainContainer = styled.div`
  max-width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  align-self: center;
  margin-bottom: 1.5rem;
`;

const BaseSlider = styled.div`
  position: relative;

  &::after,
  &::before {
    content: "";
    display: block;
    position: absolute;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0);
  }
`;

export const DateSlider = styled(BaseSlider)`
  min-width: 100%;

  &::after,
  &::before {
    height: 90%;
    width: 1rem;
    top: 0;
  }
  &::before {
    background: linear-gradient(
      to left,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.75)
    );
    left: -1px;
  }
  &::after {
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.75)
    );
    right: -1px;
  }
`;

export const DateSliderContainer = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
`;

export const DateSliderTrack = styled.div`
  overflow-y: hidden;
  overflow-x: auto;
  height: 85px;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }: PalletteProps) => theme.white};
  }
  ::-webkit-scrollbar-thumb {
  background-color: ${({ theme }: PalletteProps) => theme.gray5};
  }
`;

export const DaysWrapper = styled.ul`
  display: flex;
  flex-direction: row;
  gap: 10px;
  position: relative;
  box-sizing: border-box;
  margin-top: 0px;
  padding: 0 1rem 1rem 1rem;
`;

export const TimeMainContainer = styled.div`
  min-width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  align-self: center;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
`;

export const TimeSlider = styled(BaseSlider)`
  height: auto;

  &::after,
  &::before {
    height: 1.5rem;
    width: 96%;
  }
  &::before {
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.75)
    );
    top: 0;
  }
  &::after {
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.75)
    );
    bottom: 0;
  }
`;

export const TimeSliderContainer = styled.div`
  max-height: 200px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }: PalletteProps) => theme.white};
  }
  ::-webkit-scrollbar-thumb {
  background-color: ${({ theme }: PalletteProps) => theme.gray5};
  }
`;

export const TimeSliderTrack = styled.div`
  padding-top: 1.5rem;
`;

export const TimeWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  box-sizing: border-box;
  margin-top: 0px;
  padding: 0 1rem 1rem 1rem;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: space-between;
  justify-content: right;
  gap: 10px;
  margin: 30px 0;
  ${ClickButton} {
    width: fit-content;
    text-transform: capitalize;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    font-size: 0.875rem;
  }
`;

const BaseCtaButtons = styled.button`
  padding: 10px 20px;
  background-color: ${({ theme }: PalletteProps) => theme.lightGray};
  cursor: pointer;
  border-radius: 5px;

  &:hover {
    background-color: #ddd;
  }

  &:focus {
    outline: none;
    background-color: #ccc;
  }
`;
export const CancelButton = styled(BaseCtaButtons)``;

export const AcceptButon = styled(BaseCtaButtons)``;
